<template>
  <div>
    <div>
      <div class="coagency-list">
        <div
          class="demo-box"
          v-for="(item, index) in coagencyList"
          :key="index"
        >
          <div class="demo-img-box flex-center" @click="toDetail(item.deptId)">
            <img
              :src="
                item.deptAvatar == null || item.deptAvatar == ''
                  ? defaultDeptAvatar
                  : item.deptAvatar
              "
              alt=""
            />
          </div>
          <div class="demo-body-box">
            <el-tooltip
              :content="item.deptName"
              placement="top"
              v-ak-tooltip-auto-show
            >
              <div
                class="coagency-title ellipsis-aRow"
                @click="toDetail(item.deptId)"
                v-html="eachColor(item.deptName, searchName,$store.state.read.searchText)"
              >
                <!-- {{ item.deptName }} -->
              </div>
            </el-tooltip>

            <div class="demo-resource-box">
              <div class="coagency-info">
                商品数量
                <span>{{ item.resourceNum }}</span>
              </div>
              <div class="coagency-info">
                作者数量
                <span>{{ item.authorNum }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <noData v-if="total == 0" style="margin-top: -68px"></noData>
      <!-- <el-pagination v-show="total > 0" @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:current-page="queryParams.pageNum" :page-sizes="[10, 20, 30, 40, 50]" :page-size="queryParams.pageSize"
				layout="total, sizes, prev, pager, next, jumper" :total="total">
			</el-pagination> -->
      <div class="pagination-box" v-show="total > 0">
        <el-pagination
          class="ou-pagination"
          background
          hide-on-single-page
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryParams.pageNum"
          :page-sizes="[10, 20, 30, 40, 50]"
          :page-size="queryParams.pageSize"
          layout="total, prev, pager, next, sizes, jumper, slot"
          :total="total"
        >
          <el-button @click="getList()" class="ou-page-go">GO</el-button>
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { selectInst } from "@/api/index/index";
import noData from "@/components/noData.vue";
export default {
  data() {
    return {
      total: 0,
      //查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
      },
      coagencyList: [],
      defaultDeptAvatar: require("@/assets/images/inst_default_avatar.png"),
    };
  },
  created() {
    this.getList();
  },
  props: {
    searchName: String,
    eachColor: Function,
  },
  components: {
    noData,
  },
  methods: {
    getList(word = undefined) {
      var Params = {
        ...this.queryParams,
        word1:word||undefined,
        word2:this.$store.state.read.searchText||undefined
      };
      selectInst(Params).then((res) => {
        this.coagencyList = res.rows;
        this.total = res.total;
        this.$emit("settotal", "jgtotal", res.total);
      });
    },
    toDetail(id) {
      this.$router.push({
        path: "/coagency/coagencyDetail",
        query: {
          deptId: id,
        },
      });
    },
    // 搜索按钮操作
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    //每页条数
    handleSizeChange(val) {
      this.queryParams.pageSize = val;
      this.getList();
    },
    //当前页面
    handleCurrentChange(val) {
      this.queryParams.pageNum = val;
      this.getList();
    },
  },
};
</script>
<style scoped lang='scss'>
.coagency {
  height: auto;
  padding-bottom: 40px;
  background: #f2f2f2;

  .coagency-content {
    width: 1400px;
    min-height: 434px;
    margin: 0 auto;
    background: #fffefd;
    box-sizing: border-box;
    padding: 16px 28px 40px 24px;

    .coagency-list {
      box-sizing: border-box;
      margin: 28px 0 40px 12px;
      display: grid;
      grid-row-gap: 30px;
      column-gap: 40px;
      grid-template-columns: repeat(auto-fit, 302px);

      .demo-box {
        width: 302px;
        height: 222px;
        background: #ffffff;
        box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.1);
        box-sizing: border-box;

        .demo-img-box {
          width: 300px;
          height: 130px;
          background: #ffffff;
          cursor: pointer;

          img {
            box-sizing: border-box;
            padding: 8px 5px;
            max-width: 300px;
            max-height: 130px;
          }
        }

        .demo-body-box {
          box-sizing: border-box;
          padding: 18px 16px 20px;

          .coagency-title {
            cursor: pointer;
            width: 260px;
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #333333;
            margin-bottom: 20px;
          }

          .coagency-title:hover {
            color: #1690ff;
            text-decoration: underline;
          }

          .demo-resource-box {
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 14px;

            .coagency-info {
              font-size: 14px;
              font-family: PingFang SC;
              font-weight: 400;
              color: #666666;

              span {
                color: #0081ce;
              }
            }
          }
        }
      }
    }

    .el-pagination {
			margin-top: 10px;
      text-align: right;
    }
  }
}
</style>
